export { GOOGLE_API_CLIENT_ID } from 'constants/runtimeConfig';

// google one tap analytics
export enum GoogleOneTapMoments {
  DISPLAY = 'display',
  SKIPPED = 'skipped',
  DISMISSED = 'dismissed',
}
